import "./ResourceMappingModal.css";

import { useRef } from "react";
import Draggable from "react-draggable";
import { useNavigate } from "react-router-dom";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import apiLocalEstimate from "api/local_estimate";
import Table from "components/Table/Table";
import { getEnvVal } from "core/env.js";
import { searchNestedIterableItem } from "core/iterable_utils";

import ResourceMappingModalColumns from "./ResourceMappingModalColumns.js";

const ResourceMappingModal = ({ tableData, setResourceMappingModalVisible, setTableData, ResourceMappingItem, hideProject }) => {
	const scrollBlock = useRef(null);
	const navigate = useNavigate();

	const openLsrTc = ({ rowObj }) => {
		const prom = apiLocalEstimate.getTree(rowObj.lsr_id);

		prom.then((res) => {
			const tableData = res.data.table_data;
			const displayScrollTop = searchNestedIterableItem({
				iterable: tableData,
				isSeekRowCallback: (row) => {
					if (row.key && row.key === rowObj.key) {
						return true;
					} else {
						return false;
					}
				},
				isPermittedRowCallback: (row) => {
					if (row.visible !== false) {
						return true;
					} else {
						return false;
					}
				},
				isPermittedChildsLoopCallback: (row) => {
					if (row.childs_visible !== false || row.model_name === "CostParentLabel") {
						return true;
					} else {
						return false;
					}
				},
			});
			localStorage.setItem("displayScrollTop", displayScrollTop.seekCount);
			localStorage.setItem("scrollType", "lsr");
			localStorage.setItem("scrollKey", rowObj.key);
			localStorage.setItem("highlightRowClm", "full_row");
		});
		const navigateUrl = `/project/${rowObj.proj_id}/lsr/${rowObj.lsr_id}/`;
		if (getEnvVal("App") === "guest") {
			navigate(navigateUrl);
		} else {
			window.open(navigateUrl);
		}
	};

	const columnsData = ResourceMappingModalColumns(hideProject, openLsrTc);

	return (
		<>
			<Draggable handle=".ResourceMappingModalTitle">
				<Dialog className="ResourceMappingModal" open slotProps={{ backdrop: { style: { backgroundColor: "transparent" } } }}>
					<DialogTitle className="ResourceMappingModalTitle">
						<div>Исходные данные: {ResourceMappingItem?.name}</div>
						<div>
							<Tooltip title="Закрыть">
								<IconButton
									aria-label="Закрыть"
									onClick={() => {
										setTableData([]);
										setResourceMappingModalVisible(false);
									}}
								>
									<CloseIcon />
								</IconButton>
							</Tooltip>
						</div>
					</DialogTitle>

					<DialogContent className="ResourceMappingModalContent" ref={scrollBlock}>
						<div className="ResourceMappingModalBody">
							<div className="ResourceMappingModalTableLayout">
								<Table
									rowData={tableData}
									columnsData={columnsData}
									scrollBlock={null}
									options={{
										selectOptions: {
											controlled: true,
											expandOnSelect: {
												columnsName: ["lsr_name", "res_name"],
												fontSize: 12,
												tableClass: "ResourceMappingModalTableLayout",
											},
										},
										displayOptions: {
											scrollHeightControll: 5,
											displayScrollDelay: 20,
										},
									}}
									funcs={{
										setTableData: ({ newTableData }) => setTableData(newTableData),
										doubleClickRowAction: {
											action: (row) => openLsrTc({ rowObj: row }),
										},
									}}
								/>
							</div>
						</div>
					</DialogContent>
				</Dialog>
			</Draggable>
		</>
	);
};

export { ResourceMappingModal };
